export const sum = (values: number[]) => {
    return values?.reduce((acc, v) => (isNaN(v) ? 0 : v) + acc, 0);
};
